<div class="booking-menu booking-menu-pop card shadow">
  <div class="list-group list-group-flush">
    <ng-container *ngFor="let option of options; trackBy: trackOption">
      <button type="button"
        class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-1 ps-3 pe-2"
        [class.active]="option.key === 'coaching' && showCoaching"
        [attr.target_element]="option.key"
        [attr.aria-expanded]="option.key === 'coaching' ? showCoaching : null"
        [title]="option.title + ' (' + option.shortcut.toUpperCase() + ')'"
        (click)="pick(option)">
        <span class="flex-grow-1 text-start">{{ option.label }}{{ option.key === 'coaching' ? (showCoaching ? ' ▾' : ' ▸') : '' }}</span>
        <kbd>{{ option.shortcut.toUpperCase() }}</kbd>
      </button>

      <div *ngIf="option.key === 'coaching' && showCoaching" class="booking-menu-coaching list-group list-group-flush overflow-auto border-bottom">
        <span *ngIf="coachingPackagesLoading" class="list-group-item small text-muted ps-4">Loading…</span>
        <span *ngIf="!coachingPackagesLoading && coachingPackages.length === 0" class="list-group-item small text-muted ps-4">No coaching packages</span>
        <button *ngFor="let coachingPackage of coachingPackages; let i = index" type="button"
          class="list-group-item list-group-item-action small d-flex align-items-center gap-2 py-1 ps-4 pe-2"
          (click)="coachingChoose.emit(coachingPackage)">
          <span class="flex-grow-1 text-start">{{ coachingPackage.name }}</span>
          <kbd *ngIf="i < 9">{{ i + 1 }}</kbd>
        </button>
      </div>
    </ng-container>

    <button type="button"
      class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-1 ps-3 pe-2 text-muted"
      title="Cancel (Esc)"
      (click)="close.emit()">
      <span class="flex-grow-1 text-start">Cancel</span>
      <kbd>Esc</kbd>
    </button>
  </div>
</div>
